/**
* @author Edgar Escobedo
* @description Obtiene los creditos por paginas de documento
* @updatedDate 27-08-2024
* @param {Number} number 
* @returns {Array}
*/
const countCreditsByPages = (pages, credits, addPages) => {
    let afterPages = addPages
    let totalCredits = 0

    totalCredits = totalCredits + credits
    while (pages > afterPages) {
        totalCredits = totalCredits + credits
        afterPages += addPages
    }
    return totalCredits
}

/**
 * @author Pedro Antonio
 * @param {File} object
 * @param {string} property
 */
const getFileMediaType = (object, property) => {
    if (!object || !object[property]) return '';

    const mimeType = object[property].toLowerCase();

    const types = {
        pdf: ['application/pdf', '.pdf'],
        video: ['video/', '.mp4', '.webm', '.avi', '.mov'],
        image: ['image/', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'],
        audio: ['audio/', '.mp3', '.wav', '.m4a', '.aac', '.flac']
    };

    for (const [type, patterns] of Object.entries(types)) {
        if (patterns.some(p => mimeType.includes(p))) {
            return type;
        }
    }

    return 'unknown'
}

/**
 * @author Edgar Escobedo
 * @description Calculate the credits consumed per document when sent to OCR and Textract
 * @createdDate 03-09-2025
 * @param {[{id:Number | null, name:String, pages:Number }]} documents - List of documents to calculate credits
 * @param {function} t - Function to translate text
 * @returns 
 */
const setCreditsToDocuments = (documents, t) => {
    let docsToOCR = []
    let totalCredits = 0
    const ENV = process.env

    documents.map((doc) => {
        let pages = doc.pages
        let credits = Number(ENV.REACT_APP_OCR_ENTITIES_CREDITS)
        let addPagesOCR = Number(ENV.REACT_APP_OCR_PAGES)
        let addPagesEntities = Number(ENV.REACT_APP_ENTITIES_PAGES)
        let totalCredtisOCR = countCreditsByPages(pages, credits, addPagesOCR)
        let totalCredtisEntities = countCreditsByPages(pages, credits, addPagesEntities)

        let ocrDoc = {
            id: doc.id,
            name: doc.name,
            pages: doc.pages,
            process: t('digitalVaultUploadView.process.ocr'),
            unitary: `${process.env.REACT_APP_CREDITS_PROCESS_OCR} ${t('digitalVaultUploadView.credits.by')} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_OCR} ${t('digitalVaultUploadView.pages')}`,
            credits: totalCredtisOCR,
            value: true,
            processId: 1
        }

        let entitiesDoc = {
            id: doc.id,
            name: doc.name,
            pages: doc.pages,
            process: t('digitalVaultUploadView.process.entity.extraction'),
            unitary: `${process.env.REACT_APP_CREDITS_PROCESS_ENTITY_EXTRACTION} ${t('digitalVaultUploadView.credits.by')} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_ENTITY_EXTRACTION} ${t('digitalVaultUploadView.pages')}`,
            credits: totalCredtisEntities,
            value: true,
            processId: 2
        }

        docsToOCR.push(ocrDoc)
        docsToOCR.push(entitiesDoc)

        totalCredits = totalCredits + totalCredtisOCR + totalCredtisEntities
    })

    let data = {
        documentsToOCR: docsToOCR,
        totalCredits
    }
    return data
}

export { countCreditsByPages, getFileMediaType, setCreditsToDocuments }